import React from 'react';
import {
	TextField,
	DateField,
	ReferenceField,
	TextInput,
	SelectInput,
	SimpleForm,
	Edit,
} from 'react-admin';

import { feedbackStatuses } from './constants';
import Responses from './components/Responses';


export default ({ id, ...props }) => (
	<Edit {...props} title={`Редактирование Feedback ("${id}")`} actions={null}>
		<SimpleForm>
			<ReferenceField label="Пользователь" source="user.id" reference="User" link={false}>
				<TextField source="username" />
			</ReferenceField>
			<TextInput label="Сообщение" source="message" multiline />
			<DateField label="Отправлено" source="createdAt" showTime />
			<SelectInput label="Прочитано" source="status" choices={feedbackStatuses} />
			<TextField label="Просмотр сообщения и ответов" />
			<Responses />
		</SimpleForm>
	</Edit>
);
